import { useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { LayoutDashboard, Users, Tag, ImageIcon, ArrowLeft, ShieldCheck, History, Store, Layers, Trophy, Cpu, ShieldAlert, BarChart3, Filter } from "lucide-react";

const NAV = [
  { to: "/admin", label: "Tableau de bord", icon: LayoutDashboard, testid: "anav-dashboard", end: true },
  { to: "/admin/funnel", label: "Funnel", icon: Filter, testid: "anav-funnel" },
  { to: "/admin/analytics", label: "Analytics", icon: BarChart3, testid: "anav-analytics" },
  { to: "/admin/users", label: "Utilisateurs", icon: Users, testid: "anav-users" },
  { to: "/admin/gamification", label: "Gamification", icon: Trophy, testid: "anav-gamification" },
  { to: "/admin/ai", label: "IA", icon: Cpu, testid: "anav-ai" },
  { to: "/admin/disputes", label: "Litiges", icon: ShieldAlert, testid: "anav-disputes" },
  { to: "/admin/plans", label: "Offres", icon: Tag, testid: "anav-plans" },
  { to: "/admin/content", label: "Contenu", icon: ImageIcon, testid: "anav-content" },
  { to: "/admin/marketplace", label: "Marketplace", icon: Store, testid: "anav-marketplace" },
  { to: "/admin/catalog", label: "Catalogue", icon: Layers, testid: "anav-catalog" },
  { to: "/admin/historique", label: "Historique", icon: History, testid: "anav-audit" },
];

export function AdminLayout({ children }) {
  const { identity } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    if (identity && !identity.is_admin) navigate("/admin/login");
  }, [identity, navigate]);

  return (
    <div className="min-h-screen bg-[#0A0A0C] text-zinc-100 flex" data-testid="admin-layout">
      <aside className="hidden md:flex flex-col w-64 shrink-0 border-r border-zinc-800 bg-[#0F0F13] p-4">
        <div className="flex items-center gap-2 px-2 mb-6">
          <ShieldCheck className="w-6 h-6 text-amber-400" />
          <div>
            <p className="font-display font-extrabold leading-none">Cehnura</p>
            <p className="text-[10px] font-mono uppercase tracking-widest text-amber-500">Administration</p>
          </div>
        </div>
        <nav className="space-y-1 flex-1">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} data-testid={n.testid}
              className={({ isActive }) => `flex items-center gap-3 px-3 h-11 rounded-xl text-sm transition-colors ${isActive ? "bg-amber-500/15 text-amber-400" : "text-zinc-400 hover:text-zinc-200 hover:bg-zinc-800/50"}`}>
              <n.icon className="w-5 h-5" /> {n.label}
            </NavLink>
          ))}
        </nav>
        <button onClick={() => navigate("/dashboard")} data-testid="admin-back-app"
          className="flex items-center gap-2 px-3 h-11 rounded-xl text-sm text-zinc-400 hover:text-zinc-200 hover:bg-zinc-800/50">
          <ArrowLeft className="w-5 h-5" /> Retour à l'app
        </button>
      </aside>

      <div className="flex-1 min-w-0">
        <header className="md:hidden flex items-center gap-2 border-b border-zinc-800 p-3 overflow-x-auto">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} data-testid={`m-${n.testid}`}
              className={({ isActive }) => `whitespace-nowrap px-3 h-9 flex items-center rounded-lg text-xs ${isActive ? "bg-amber-500/15 text-amber-400" : "text-zinc-400 bg-zinc-900"}`}>
              {n.label}
            </NavLink>
          ))}
          <button onClick={() => navigate("/dashboard")} className="whitespace-nowrap px-3 h-9 rounded-lg text-xs text-zinc-400 bg-zinc-900">← App</button>
        </header>
        <main className="p-4 md:p-8 max-w-6xl mx-auto">{children}</main>
      </div>
    </div>
  );
}
